export default __webpack_public_path__ + "static/media/app-store-promo.9e4a37e1.mp4";